class Format {
  static formatCoverage(type, value) {
    switch (type) {
      case 'Money':
        return Format.formatMoney(value);
      case 'Bit':
        return Format.formatBool(value);
      case 'Date':
        return Format.formatDate(value);
      default:
        return value;
    }
  }

  static formatDate(strDate) {
    if (strDate) {
      return Format.getFormattedDate(new Date(strDate));
    }

    return strDate;
  }

  static getFormattedDate(date) {
    const year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : `0${month}`;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : `0${day}`;

    return `${month}/${day}/${year}`;
  }

  static formatMoney(strMoney) {
    if (strMoney) {
      return Format.getFormattedMoney(strMoney.toString());
    }

    return strMoney;
  }

  static getFormattedMoney(val) {
    let newValue = val;
    // eslint-disable-next-line no-bitwise
    if (~newValue.indexOf('$')) {
      newValue = val.replace('$', '').replace(/,/g, '');
    }

    let decimalPart = '';
    // eslint-disable-next-line no-bitwise
    if (~val.indexOf('.')) {
      decimalPart = val.substr(val.indexOf('.'));
      newValue = val.substr(0, val.indexOf('.'));
      if (decimalPart === 0) {
        decimalPart = '';
      }
    }

    return `$${newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${decimalPart}`;
  }

  static formatBool(strBool) {
    return strBool && strBool.length > 0 && strBool.toLowerCase() === 'true'
      ? 'Yes'
      : 'No';
  }

  static formatPhoneOrFax = phone => {
    if (!phone) {
      return '';
    }

    const phoneStr = phone.toString();

    if (phoneStr.length <= 3) {
      return `(${phone}`;
    }

    if (phoneStr.length <= 6) {
      return `(${phoneStr.slice(0, 3)}) ${phoneStr.slice(3)}`;
    }

    return `(${phoneStr.slice(0, 3)}) ${phoneStr.slice(3, 6)}-${phoneStr.slice(
      6,
      10,
    )}`;
  };

  static formatPhoneExtension = phoneExt => {
    if (!phoneExt) {
      return '';
    }

    return phoneExt.toString();
  };
}

export default Format;
